import { MessageCircle } from "lucide-react";
import { useConfig, waLink } from "@/context/ConfigContext";

export default function WhatsAppFloat() {
  const config = useConfig();
  return (
    <a
      href={waLink(config)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      data-testid="whatsapp-float-button"
      className="fixed bottom-5 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform duration-200 hover:scale-110"
    >
      <MessageCircle className="h-6 w-6" aria-hidden="true" />
    </a>
  );
}
